import type { ReactNode } from "react";

import { cn } from "./cn";

/** Section heading inside content: optional eyebrow, h1, optional right slot. */
export function LargeTitle({
  title,
  eyebrow,
  children,
  className,
}: {
  title: ReactNode;
  eyebrow?: ReactNode;
  /** Right-hand slot, e.g. a round menu button. */
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex items-end justify-between gap-3", className)}>
      <div className="min-w-0 flex-1">
        {eyebrow !== undefined && (
          <p className="text-footnote text-fg-muted">{eyebrow}</p>
        )}
        <h1 className="text-large-title tracking-large-title text-fg">
          {title}
        </h1>
      </div>
      {children}
    </div>
  );
}
